// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Grave_bookGao__z5IoC:hover {\n    transform: scale(1.1);\n    transition: all 0.25s ease-in;\n    transition: all 0.25s ease-out;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/Mobile/Grave/index.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,8BAA8B;AAClC","sourcesContent":[".bookGao:hover {\n    transform: scale(1.1);\n    transition: all 0.25s ease-in;\n    transition: all 0.25s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookGao": "Grave_bookGao__z5IoC"
};
export default ___CSS_LOADER_EXPORT___;
